export default "__VITE_ASSET__c3af79a4__"